export default __webpack_public_path__ + "static/media/deliveredIconRed.e2f05952.svg";